import React from 'react';
import 'react-dom';
import { Component } from '@gondel/core';
import { GondelReactComponent } from '@gondel/plugin-react';
import addComponentAnimation from '@swisslife/shared-ui/src/utils/animations/js/animations';

@Component('Quiz')
export class Quiz extends GondelReactComponent<any> {
	private QuizReact: React.ComponentType<any>;
	private controllers: any[] = Array();

	public async start() {
		// tslint:disable-next-line
		this.QuizReact = ((await import(/* webpackChunkName: "dynamic-imports/quiz" */ './Quiz')) as any).Quiz;
		this.controllers = await addComponentAnimation($('.o-quiz'));
	}

	public stop() {
		for (const controller of this.controllers) {
			controller.destroy(true);
		}
	}
	/**
	 * This component is the bridge between gondel and react
	 * and does nothing less than rendering the navigation list
	 * via react.
	 */
	public render() {
		const QuizReact = this.QuizReact;
		return <QuizReact {...this.state} />;
	}
}
